// extracted by mini-css-extract-plugin
export var columnItem = "_bp-3";
export var columnItemDraggable = "_bp-4";
export var dragHandle = "_bp-0";
export var dragHandleHovered = "_bp-1";
export var dropdown = "_bp-5";
export var dropdownContent = "_bp-7";
export var dropdownInner = "_bp-6";
export var filterDropdownHeader = "_bp-8";
export var icon = "_bp-2";
export var sectionDivider = "_bp-9";